
module.exports = function (Restangular) {
    function RingCaptchaService() {
        this._api = Restangular.one('RingCaptcha');

        this.isFormSubmittedSuccessfully = false;
    }

    RingCaptchaService.prototype.code = function (phonenumber, useGoogleReCaptcha, googleReCaptchaResponse) {
        return this._api.post('Code', { phonenumber, useGoogleReCaptcha, googleReCaptchaResponse });
    };

    RingCaptchaService.prototype.verify = function (token, code) {
        return this._api.post('Verify', { token, code });
    };

    RingCaptchaService.prototype.token = '';

    return new RingCaptchaService();
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/selfexclusion/ringcaptcha-service.js
 **/